// src/classes/ReservationDetails.js
import ReservationGuest from './ReservationGuest';

export default class ReservationDetails {
    constructor(reservationId, primaryProfileId, accompanyingProfileIds) {
        this.reservations = [
            {
                reservationIdList: [
                    {
                        type: "Reservation",
                        id: reservationId
                    }
                ],
                reservationGuests: [
                    new ReservationGuest(primaryProfileId, true),
                    ...accompanyingProfileIds.map(
                        (profileId) => new ReservationGuest(profileId, false)
                    )
                ]
            }
        ];
    }
}
